import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconDollarSquare: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6875 1.875H5.3125C3.09583 1.875 1.875 3.09583 1.875 5.3125V14.6875C1.875 16.9042 3.09583 18.125 5.3125 18.125H14.6875C16.9042 18.125 18.125 16.9042 18.125 14.6875V5.3125C18.125 3.09583 16.9042 1.875 14.6875 1.875ZM16.875 14.6875C16.875 16.2 16.2 16.875 14.6875 16.875H5.3125C3.77917 16.875 3.125 16.2208 3.125 14.6875V5.3125C3.125 3.77917 3.77917 3.125 5.3125 3.125H14.6875C16.2 3.125 16.875 3.8 16.875 5.3125V14.6875ZM10.8217 9.56004L9.48166 9.2275C9.27499 9.17583 9.09917 9.05995 8.96667 8.89079C8.84167 8.73245 8.77248 8.52917 8.77248 8.32001C8.77248 7.80417 9.19166 7.38505 9.70749 7.38505H10.2908C10.7675 7.38505 11.1667 7.74338 11.2209 8.21838C11.2592 8.56172 11.5658 8.81004 11.9117 8.77004C12.255 8.73171 12.5017 8.42246 12.4633 8.07912C12.3508 7.07746 11.5758 6.30498 10.6058 6.16414V5.83333C10.6058 5.48833 10.3258 5.20833 9.98082 5.20833C9.63582 5.20833 9.35582 5.48833 9.35582 5.83333V6.17004C8.31832 6.34004 7.52248 7.23503 7.52248 8.31919C7.52248 8.80836 7.68665 9.2867 7.98248 9.66003C8.27915 10.0425 8.7025 10.3191 9.1775 10.4391L10.5175 10.7717C10.935 10.8775 11.2267 11.2508 11.2267 11.6792C11.2267 11.9275 11.1292 12.1617 10.9517 12.3392C10.7742 12.5167 10.54 12.6141 10.2916 12.6141H9.70835C9.23169 12.6141 8.8325 12.2558 8.77833 11.7808C8.74 11.4375 8.42835 11.1875 8.08751 11.2291C7.74418 11.2675 7.49752 11.5766 7.53586 11.92C7.64669 12.9091 8.40332 13.6767 9.35582 13.8309V14.1667C9.35582 14.5117 9.63582 14.7917 9.98082 14.7917C10.3258 14.7917 10.6058 14.5117 10.6058 14.1667V13.835C11.0683 13.7675 11.4975 13.5625 11.835 13.225C12.2484 12.8117 12.4767 12.2633 12.4767 11.6808C12.4767 10.6783 11.7975 9.80754 10.8217 9.56004Z"
      fill={color}
    />
  </svg>
);

export default IconDollarSquare;
